import { render } from "./InstallWizardIndex.vue?vue&type=template&id=23083f9c"
import script from "./InstallWizardIndex.vue?vue&type=script&lang=js"
export * from "./InstallWizardIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__